namespace $.$$ {

	export class $shm_projects_card extends $.$shm_projects_card {

		project() {
			return this.$.$shm_projects_data.detail( this.project_id() )
		}

		project_title() {
			return this.project()?.title ?? this.project_id()
		}

		project_version() {
			const version = this.project()?.version ?? ''
			return version ? `v${ version }` : '—'
		}

		project_prerelease() {
			const version = this.project()?.channels?.prerelease ?? ''
			return version ? `v${ version }` : '—'
		}

		project_prerelease_record() {
			const project = this.project()
			const channel = project?.channels?.prerelease
			if( !project || !channel ) return null
			return project.history.find( version =>
				version.stage === 'Пререлиз' && version.version === channel
			) ?? null
		}

		project_prerelease_arg() {
			const version = this.project_prerelease_record()
			return {
				... this.project_arg(),
				project_tab: 'history',
				project_version: version?.id ?? null,
				project_version_output: version ? 'result' : null,
			}
		}

		project_release() {
			const version = this.project()?.channels?.release ?? ''
			return version ? `v${ version }` : '—'
		}

		project_version_date() {
			const date = this.project()?.version_date ?? ''
			return date && date !== '-' ? date : '—'
		}

		project_arg() {
			return {
				section: 'projects',
				project: this.project_id(),
				project_tab: 'tasks',
				projects_map: null,
			}
		}

	}

}
